var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#00D994",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#00D994",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4815 11.2575C11.3578 11.2575 11.2575 11.3578 11.2575 11.4815V16.1495C11.2575 16.2732 11.3578 16.3735 11.4815 16.3735H16.1495C16.2732 16.3735 16.3735 16.2732 16.3735 16.1495V11.4815C16.3735 11.3578 16.2732 11.2575 16.1495 11.2575H11.4815ZM9.63086 11.4815C9.63086 10.4594 10.4594 9.63086 11.4815 9.63086H16.1495C17.1716 9.63086 18.0002 10.4594 18.0002 11.4815V16.1495C18.0002 17.1716 17.1716 18.0002 16.1495 18.0002H11.4815C10.4594 18.0002 9.63086 17.1716 9.63086 16.1495V11.4815Z",
    fill: "#00D994",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85067 7.62669C7.79127 7.62669 7.7343 7.65029 7.69229 7.69229C7.65029 7.7343 7.62669 7.79127 7.62669 7.85067V12.5187C7.62669 12.5781 7.65028 12.635 7.69229 12.6771C7.7343 12.7191 7.79127 12.7427 7.85067 12.7427H8.36934C8.81854 12.7427 9.18268 13.1068 9.18268 13.556C9.18268 14.0052 8.81854 14.3693 8.36934 14.3693H7.85067C7.35985 14.3693 6.88912 14.1744 6.54205 13.8273C6.19498 13.4802 6 13.0095 6 12.5187V7.85067C6 7.35985 6.19498 6.88912 6.54205 6.54205C6.88912 6.19498 7.35985 6 7.85067 6H12.5187C13.0095 6 13.4802 6.19498 13.8273 6.54205C14.1744 6.88912 14.3693 7.35985 14.3693 7.85067V8.36934C14.3693 8.81854 14.0052 9.18268 13.556 9.18268C13.1068 9.18268 12.7427 8.81854 12.7427 8.36934V7.85067C12.7427 7.79127 12.7191 7.7343 12.6771 7.69229C12.635 7.65028 12.5781 7.62669 12.5187 7.62669H7.85067Z",
    fill: "#00D994",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.59e73cc900a9c43c1c64e7fdfdf31e8d.svg";
export { ForwardRef as ReactComponent };